<template>
  <div class="breadcrumb-title-container" :class="color">
    <div class="vertical-line"></div>
    <div class="flex-col">
      <breadcrumb />
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../molecules/breadcrumb";
export default {
  name: "title-and-breadcrumb",
  components: {
    Breadcrumb
  },
  props: {
    title: String,
    color: String
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.breadcrumb-title-container {
  display: flex;
  .vertical-line {
    background-color: black;
    width: 2px;
    margin-right: 1rem;
  }

  h1 {
    font-weight: 400;
    font-family: "Lora";
  }

  &.white {
    .vertical-line {
      background-color: white;
    }

    h1 {
      color: white;
    }
  }
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";

.breadcrumb-title-container.white {
  .bc,
  .material-icons {
    color: white;
  }
}
</style>
